module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Ultra Narrow_Thin NB Camera.30752464.png";